import React from "react";
import { NavLink, NavLinkProps, NavLinkRenderProps } from "react-router-dom";
import styles from "./profile-menu.module.css";
import { clsx } from 'clsx';
import Heading from "../heading/heading";

const ProfileMenu = () => {

    const navLinkClass: NavLinkProps["className"] = (
        { isActive, isPending }: NavLinkRenderProps
    ) =>
        clsx(
            styles.menuDefault,
            {
                [styles.menuPending as string]: isPending,
                [styles.menuActive as string]: isActive && !isPending,
            }
        );
    return (
        <>
            <Heading tpl="new">Профиль</Heading>
            <nav className={styles.nav}>
                <div className={styles.menu}>
                    <NavLink to="/profile/info" className={navLinkClass}>
                        Основные
                    </NavLink>
                    <NavLink to="/profile/interests" className={navLinkClass}>
                        Интересы
                    </NavLink>
                    <NavLink to="/profile/lifestyle" className={navLinkClass}>
                        Образ жизни
                    </NavLink>
                    <NavLink to="/profile/photos" className={navLinkClass}>
                        Фото
                    </NavLink>
                </div>
            </nav>
        </>
    );
}

export default ProfileMenu;
